import { isEmpty, isEmail, isOnlyDigits, isAlphabetsWithSpace } from '../../libs/validation/validators'

export default function validateAuth(values) {
    let errors = {};
    Object.keys(values).map(key => {
        switch (key) {
            case "name":
                if (!values.name) {
                    errors.name = "Please enter valid name";
                }
                else if (!isEmpty(values.name) && !isAlphabetsWithSpace(values.name.trim())) {
                    errors.name = "Full name should have only alphabats and space only";
                }
                break;
            case "emailid":
                if (isEmpty(values.emailid)) {
                    errors.emailid = "Email ID cannot be left blank";
                } else if (!isEmail(values.emailid)) {
                    errors.emailid = "Email ID format should be : name@example.com";
                }
                break;
            case "mobileno":
                if (!values.mobileno) {
                    errors.mobileno = "Mobile Number cannot be left blank";
                } else if (values.mobileno.length < 10) {
                    errors.mobileno = "Please enter a valid 10-digit mobile number";
                }
                break;
            case "password":
                if (isEmpty(values.password)) {
                    errors.password = "Password cannot be left blank";
                } else if (values.password.length < 6) {
                    errors.password = "Your password needs to have at least 8 characters, 1 special";
                }
                break;
            case "organization":
                if (!values.organization) {
                    errors.organization = "Please enter valid Organization name";
                }
                else if (!isEmpty(values.organization) && !isAlphabetsWithSpace(values.organization.trim())) {
                    errors.organization = "Organization name should have only alphabats and space only";
                }
                break;
        }
        console.log(errors)
    });

    return errors;
}
